import { Box } from "@mui/material";
import { ReactNode } from "react";

import { space } from "../theme/designTokens";

type InfoPanelLayoutProps = {
  children: ReactNode;
};

export const InfoPanelLayout = ({ children }: InfoPanelLayoutProps) => {
  return (
    <Box sx={{ ml: { xs: 0, sm: `${space.sm}px` }, minWidth: 0, maxWidth: "100%" }}>
      <Box sx={{ display: { xs: "block", sm: "inline-block" }, maxWidth: "100%" }}>{children}</Box>
    </Box>
  );
};
